import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {AuthenticationService} from "./authentication.service";
import {commonProperties} from "../../../assets/environments/environment.common";

import {environment} from "../../../assets/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class JwtInterceptorService implements HttpInterceptor {

  constructor(public auth: AuthenticationService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (this.auth.isAuthenticated() && !(req.method === 'POST' && req.url === environment.api_root + commonProperties.companyCreation)) {
      req = req.clone({
        setHeaders: {
          Authorization: localStorage.getItem(AuthenticationService.TOKEN)
        }
      });
    }
    return next.handle(req);
  }
}

